module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones@2x-912b282ed855ff9bb98fb9210006e825.png";